export const OFFER_TYPES = {
  CONTRACTED: 'Contracted',
  LOAD_CANDIDATE: 'ShipperDirect',
  VIP: 'VIP',
  REGULAR: 'Regular',
}

export function getLoadOfferType(loadOffer) {
  const contract = loadOffer.active_offer ? loadOffer.active_offer.contract : loadOffer.contract
  const isContracted = Boolean(contract)

  const isDaimlerVIP = loadOffer.active_offer
    ? loadOffer.active_offer.daimler_vip
    : loadOffer.daimler_vip
  const isLoadCandidate = loadOffer.load ? loadOffer.load.load_candidate : loadOffer.load_candidate

  if (isContracted) return OFFER_TYPES.CONTRACTED
  if (isLoadCandidate) return OFFER_TYPES.LOAD_CANDIDATE
  if (isDaimlerVIP) return OFFER_TYPES.VIP

  return OFFER_TYPES.REGULAR
}
